import { render } from "./FadeTransition.vue?vue&type=template&id=d478b75a"
const script = {}

import "./FadeTransition.vue?vue&type=style&index=0&id=d478b75a&lang=css"

import exportComponent from "C:\\Server-Testumgebung\\way-academy-app-main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__